import Profile from './Profile.jsx';
import ChangePassword from './ChangePassword.jsx';
import Complaint from './Complaint.jsx';
import ComplaintDetail from './ComplaintDetail.jsx';
import Dashboard from './Dashboard.jsx';
import Announcement from './Announcement.jsx';
import SendComplaint from './SendComplaint.jsx';
import SendNeedoffer from './SendNeedoffer.jsx';
import FavoriteProduct from './FavoriteProduct.jsx';
import MemberZone from './MemberZone.jsx';
import MyDemand from './MyDemand.jsx';
import PostDemandPage from './PostDemandPage.jsx';
import MyRequests from './MyRequests.jsx';
import RequestDetail from './RequestDetail.jsx';
import MyShoppingCartPage from './MyShoppingCartPage.jsx';
import AnnouncementDetail from './AnnouncementDetail.jsx';
import MyDemandDetailPage from './MyDemandDetailPage.jsx';
import OrderHistory from './OrderHistory.jsx';
import OrderHistoryDetail from './OrderHistoryDetail.jsx';

export {
  Profile,
  ChangePassword,
  Complaint,
  ComplaintDetail,
  Dashboard,
  Announcement,
  SendComplaint,
  SendNeedoffer,
  FavoriteProduct,
  MemberZone,
  MyDemand,
  PostDemandPage,
  MyRequests,
  RequestDetail,
  MyShoppingCartPage,
  AnnouncementDetail,
  MyDemandDetailPage,
  OrderHistory,
  OrderHistoryDetail
};



// WEBPACK FOOTER //
// ./pages/users/index.js